<div class="document-types-container" [class.document-types-container--embedded]="embedded">
  <div class="header" *ngIf="!embedded">
    <div class="header-left">
      <a routerLink="/customs-broker/dashboard/settings" class="btn-back">← {{ backText }}</a>
      <h1>{{ titleText }}</h1>
    </div>
  </div>

  <div class="header" *ngIf="embedded">
    <h2>{{ titleText }}</h2>
  </div>

  <p class="hint">
    {{ hintText }}
  </p>

  <div *ngIf="error" class="error-message">{{ error }}</div>

  <!-- ── Форма добавления ──────────────────────────────────────────────── -->
  <form [formGroup]="createForm" class="create-form" (ngSubmit)="onCreate()">
    <div class="create-form__row">
      <input
        type="text"
        formControlName="name"
        class="form-control"
        [placeholder]="namePlaceholderText"
      />
      <input
        type="text"
        formControlName="hint"
        class="form-control form-control--hint"
        [placeholder]="aiHintPlaceholderText"
      />
      <button type="submit" class="btn btn-primary" [disabled]="creating">
        {{ creating ? addingText : addText }}
      </button>
    </div>
  </form>

  <div *ngIf="loading" class="loading-message">{{ loadingText }}</div>

  <!-- ── Список типов ──────────────────────────────────────────────────── -->
  <div class="table-scroll" *ngIf="!loading && types.length > 0">
    <table class="types-table">
      <thead>
        <tr>
          <th>{{ columnNameText }}</th>
          <th>{{ columnAiHintText }}</th>
          <th>{{ columnActionsText }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let type of types" [class.row-editing]="editingId === type.id">
          <ng-container *ngIf="editingId === type.id; else viewRow">
            <td colspan="3">
              <form [formGroup]="editForm" class="edit-form">
                <input type="text" formControlName="name" class="form-control" [placeholder]="editNamePlaceholderText" />
                <input type="text" formControlName="hint" class="form-control form-control--hint" [placeholder]="editAiHintPlaceholderText" />
                <button type="button" class="btn btn-primary btn-small" [disabled]="saving[type.id]" (click)="saveEdit(type)">
                  {{ saving[type.id] ? '...' : saveText }}
                </button>
                <button type="button" class="btn btn-secondary btn-small" (click)="cancelEdit()">{{ cancelText }}</button>
              </form>
            </td>
          </ng-container>
          <ng-template #viewRow>
            <td>{{ type.name }}</td>
            <td class="hint-cell">{{ type.hint || '—' }}</td>
            <td class="row-actions">
              <button type="button" class="btn btn-secondary btn-small" (click)="startEdit(type)">{{ editText }}</button>
              <button
                type="button"
                class="btn btn-danger btn-small"
                [disabled]="deleting[type.id]"
                (click)="deleteType(type)"
              >
                {{ deleting[type.id] ? '...' : deleteText }}
              </button>
            </td>
          </ng-template>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && types.length === 0" class="empty-state">
    {{ emptyStateText }}
  </div>
</div>
